import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Button } from "evergreen-ui";

const ButtonLink = (props) => <Button is={RouterLink} {...props} />;

export default ButtonLink;
